import * as yup from 'yup';
import { AvailableType, QuantityType } from '../../listItem/conf/Data.conf';

export const UpdateConf = {
  schema: yup.object({
    available: yup.string().nullable().required('Available is required'),
    quantity: yup.string().nullable().required('Quantity is required'),
    quantity_type: yup.string().nullable().required('Type is required'),
    note: yup.string().nullable(),
    internal_note: yup.string().nullable(),
  }),
  defaultValues: {},
  fields: [],
};

export const UpdateProductConf = {
  schema: yup.object({
    available: yup.object().nullable().required('Available is required'),
    quantity: yup.string().nullable().required('Quantity is required'),
    quantity_type: yup.object().nullable().required('Type is required'),
    id_item: yup.object().nullable().required('Product is required'),
    category: yup.object().nullable(),
    note: yup.string().nullable(),
    internal_note: yup.string().nullable(),
  }),
  defaultValues: {
    available: null,
    quantity: '',
    quantity_type: null,
    id_item: null,
    note: '',
    category: null,
    internal_note: '',
  },
  fields: [
    {
      id: 'id_item',
      name: 'id_item',
      type: 'autocomplete',
      label: 'Product',
      options: [],
      required: true,
      xs: 12,
      sm: 6,
      disabled: true,
    },
    {
      id: 'quantity',
      name: 'quantity',
      type: 'number',
      label: 'Quantity',
      xs: 12,
      sm: 2,
      md: 1.5,
      required: true,
    },
    {
      id: 'quantity_type',
      name: 'quantity_type',
      type: 'autocomplete',
      label: 'Type',
      options: QuantityType,
      xs: 12,
      sm: 2,
      md: 2,
      required: true,
    },
    {
      id: 'available',
      name: 'available',
      type: 'autocomplete',
      label: 'Available',
      options: AvailableType,
      required: true,
      xs: 12,
      sm: 3,
      md: 2.5,
    },
    {
      id: 'note',
      name: 'note',
      type: 'text_multiline',
      label: 'Note',
      xs: 12,
      rows: 2,
    },
    {
      id: 'internal_note',
      name: 'internal_note',
      type: 'text',
      label: 'Internal Note',
      xs: 12,
    },
  ],
};
